var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vg-card',[_c('vg-form',_vm._l((_vm.subjectList),function(item){return _c('vg-field',{key:item.id.value,attrs:{"label":item.billingAccountName,"is-link":""},on:{"click":function($event){return _vm.choiceProject(item)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }